module.exports = __webpack_public_path__ + "img/hover.94b1a7ca.png";